import { MisalignmentItem } from "PFApp/booking/types";
import { minutesToHours } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import ExternalLinkIconSvg from "PFIcons/external_link.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./warning_tooltip_content.module.scss";

interface IProps {
  roleName?: string;
  misalignments: MisalignmentItem[];
  onLinkClick?: () => void;
}

const ExternalLinkIcon = (props) => <ExternalLinkIconSvg {...props} />;

const MisalignmentErrorDetails = ({ roleName, misalignments, onLinkClick }: IProps) => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  const { formatDateTime, utc } = useDateFormatter();

  const getFormattedError = (errorType, errorValue: number | string) =>
    errorType === "duration" ? `${minutesToHours(errorValue as number)}h` : formatDateTime(utc(errorValue));

  const errorTypeLabels = {
    duration: t("translation:duration"),
    start_date: t("translation:startDate"),
    end_date: t("translation:endDate")
  };

  return (
    <div className={css.misalignmentDetailsRoot}>
      <div className={css.misalignmentDetailsItemRow}>
        {onLinkClick && (
          <ExternalLinkIcon
            className={css.misalignmentDetailsLinkIcon}
            onClick={onLinkClick}
            width={18}
            height={18}
          />
        )}
        {!!roleName && <div className={css.misalignmentDetailsRoleName}>{roleName}</div>}
      </div>
      {misalignments.map(({ errors }, index) =>
        Object.entries(errors)
          .filter(([, errorValues]) => errorValues.length === 2)
          .map(([errorType, errorValues], i) => {
            const expected = getFormattedError(errorType, errorValues[0]);
            const current = errorValues[1] != null ? getFormattedError(errorType, errorValues[1]) : null; // eslint-disable-line eqeqeq
            return (
              <div key={`${index}_${i}`} className={css.misalignmentDetailsItem}>
                <div className={css.misalignmentDetailsItemRow}>
                  <span>{errorTypeLabels[errorType]}:</span>
                  <span>{t("bookingModule:projects.misalignmentExpected", { expected })}</span>
                  {current != null && ( // eslint-disable-line eqeqeq
                    <>
                      <span>-</span>
                      <span>{t("bookingModule:projects.misalignmentCurrent", { current })}</span>
                    </>
                  )}
                </div>
              </div>
            );
          })
      )}
    </div>
  );
};

export default MisalignmentErrorDetails;
